import * as React from 'react';
import { Node, Alert } from '@msdyn365-commerce-modules/utilities';

export interface IAlertBlockProps {
    headerMessage?: string;
    errorMessages: string[];
}

const AlertBlock: React.FC<IAlertBlockProps> = ({ headerMessage, errorMessages }) => {
    if (!errorMessages || errorMessages.length === 0) {
        return null;
    }

    const alertProps = {
        tag: Alert,
        className: 'msc-alert',
        isOpen: true,
        color: 'danger',
        assertive: true,
        'aria-label': headerMessage
    };

    return (
        <Node {...alertProps}>
            <div className='msc-alert__header' aria-hidden='true'>
                <span className='msi-exclamation-triangle' />
                <span>{headerMessage}</span>
            </div>
            {errorMessages.map((message, index) => (
                <div key={index} className='msc-alert__line'>
                    {message}
                </div>
            ))}
        </Node>
    );
};

export default AlertBlock;
